import { OrganizationKeyName } from "../../../model/Organization";

export const GET_NEWS_LIST_FAIL = "SHOP:GET_NEWS_LIST_FAIL";

export const getNewsListFailAction = (organization: OrganizationKeyName) => ({
  type: GET_NEWS_LIST_FAIL as typeof GET_NEWS_LIST_FAIL,
  organization,
});

export type GetNewsListFailAction = ReturnType<typeof getNewsListFailAction>;
